import { Directive } from '@angular/core';

@Directive({
  selector: '[xpo-action-button], [xpoActionButton]',
  host: {
    class: 'xpo-ActionButton',
  },
})
export class XpoActionButton {}
